import React, { Component } from 'react';
import _, { isEmpty } from 'lodash';
import $ from 'jquery';
import { IReducerState } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import { RenditionLoadable } from '../../../utils/general/LoadableRelated';
import { checkDomEntitlement } from '../../../utils/general/checkDomEntitlement';
import * as HTML_RENDITION from '../../../utils/general/general';
import { RSCH_HTML_TRACKING_CONFIG } from '../../../readership/trackingConfig';
import { fetchFinSumData } from './financials/fetchFinsumData';
import * as commonStateAction from "../../../actions/commonStateAction";
import commonStore from "../../../store/commonStore";
import * as deviceInfoService from '../../../utils/general/deviceInfoService';
import { enterKeyPressed } from '../../../utils/general/enterKey';
import RenditionUrlGenerator from '../../../utils/api/renditionUrlGenerator';
import { getStaticEPFAccessToken } from '../../../utils/general/EpfTokensUtils';
import { addParam } from '../../../utils/general/general';

interface IFinancialsAndIndustryProps {
    source?: any;
    docHeaderSectionJson: any;
    initialData: any;
    multiCompanyMetaData: any;
    finSumData: any;
    updateFinancialsContentTabTitle: number;
    menuPaneStatus: string;
    restrictionStatus?: boolean;
    showOldBranding: boolean;
    showAnalystModelComp: boolean;
}

const ModalPopup = RenditionLoadable({
    loader: () => import('../../../modalrelated/modalPopup'),
}, "modalPopup", Date.now());

const NormalScreenPopup = RenditionLoadable({
    loader: () => import('../../../modalrelated/normalScreenPopup'),
}, "normalScreenPopup", Date.now());

const TabsFinancialsContent = RenditionLoadable({
    loader: () => import('./financials/tabsFinancialsContent'),
}, "tabsFinancialsContent", Date.now());

const ShowErrorPopup = RenditionLoadable({
    loader: () => import('../../../mainpage/showErrorPopup'),
}, "showErrorPopup", Date.now());

export class FinancialsAndIndustry extends Component<IFinancialsAndIndustryProps, any> {
    public MULTI_TAB_STATAB_FINSUM: any;
    public INDUSTRY_COMPARABLES: any;
    public currentSelectedCompanyCode = window.HTML_RENDITION.isMCN ?
                                            this.props.multiCompanyMetaData?.companyCode :
                                            this.props.docHeaderSectionJson.metadata.companyCode;
    constructor(props: IFinancialsAndIndustryProps) {
        super(props);
        this.MULTI_TAB_STATAB_FINSUM = React.createRef();
        this.INDUSTRY_COMPARABLES = React.createRef();
        this.state = {
            modalStatus: false,
            selectComp: 0,
        };
    }

    public componentDidMount() {
        this.checkCurrentCompoentDOMEntit();
    }

    public shouldComponentUpdate(nextProps: IFinancialsAndIndustryProps, nextState: any) {
        const { initialData, docHeaderSectionJson } = this.props;
        const productType = initialData.productType;
        if (productType !== 'multicompany' || nextProps.restrictionStatus !== this.props.restrictionStatus) {
            return true;
        }
        if (!_.isNull(this.props.multiCompanyMetaData) &&
            !_.isUndefined(this.props.multiCompanyMetaData) &&
            !_.isUndefined(nextProps.multiCompanyMetaData)) {
            if ((this.props.multiCompanyMetaData.companyCode == nextProps.multiCompanyMetaData.companyCode)) {
                return true;
            }
            return false;
        }
        return false;
    }

    public showFinancials() {
        const { docHeaderSectionJson, multiCompanyMetaData } = this.props;
        if (window.HTML_RENDITION.isMCN) {
            const multiCompanyCode = multiCompanyMetaData?.companyCode;
            if (window.HTML_RENDITION.initialData.isFAVE){
                return multiCompanyCode;
            }
            if (!docHeaderSectionJson.FinSumMeta || $.isEmptyObject(docHeaderSectionJson.FinSumMeta)) {
                return false;
            }
            return multiCompanyCode ? docHeaderSectionJson.FinSumMeta[multiCompanyCode]?.containsFinancialSummary : multiCompanyCode;
        } else {
            return docHeaderSectionJson.issuerPage?.financialsBlock?.financialsFlag == "true"
                && docHeaderSectionJson.FinancialSummary?.containsFinancialSummary;
        }
    }

    public showIndustryComp() {
        const { initialData, docHeaderSectionJson, multiCompanyMetaData } = this.props;
        if (window.HTML_RENDITION.isMCN) {
            const multiCompanyCode = multiCompanyMetaData?.companyCode;
            if (!docHeaderSectionJson.FinSumMeta || $.isEmptyObject(docHeaderSectionJson.FinSumMeta)) {
                return false;
            }
            return multiCompanyCode ? docHeaderSectionJson.FinSumMeta[multiCompanyCode]?.containsIndustryComp : multiCompanyCode;
        } else {
            return docHeaderSectionJson.FinancialSummary
                && docHeaderSectionJson.FinancialSummary.containsIndustryComp
                && initialData.showIndustryComp == "true";
        }
    }

    public checkCurrentCompoentDOMEntit() {
        this.MULTI_TAB_STATAB_FINSUM.current && checkDomEntitlement(this.MULTI_TAB_STATAB_FINSUM.current);
        this.INDUSTRY_COMPARABLES.current && checkDomEntitlement(this.INDUSTRY_COMPARABLES.current);
    }

    public openModal(e: any) {
        if (e.target.id === "modalClose") {
            commonStore.dispatch(commonStateAction.updateFinancialsContentTabTitle(0));
            this.setState({
                modalStatus: false,
            });
            $('.triggered_popup_flag').focus().removeClass('triggered_popup_flag');
        } else if (this.state.modalStatus === false) {
            this.setState({
                modalStatus: true,
                selectComp: e.target.id == 'requestFinancials-industryComp'
            });
            e.target.className += " triggered_popup_flag";
            if (this.MULTI_TAB_STATAB_FINSUM.current){
                RSCH_HTML_TRACKING_CONFIG.trackRequestFinancials();
            }
            if (this.INDUSTRY_COMPARABLES.current){
                RSCH_HTML_TRACKING_CONFIG.trackIndustryComparablesClick();
            }
        }
    }

    public showModal () {
        let companyCodeChangedFlag = true;
        // adding comapny23 financials popup url
        const environment = window.HTML_RENDITION.initialData.environment;
        let ticker = this.props.docHeaderSectionJson.metadata.ticker;
        if (window.HTML_RENDITION.isMCN) {
          if (!_.isEmpty(this.props.multiCompanyMetaData)) {
            ticker = this.props.multiCompanyMetaData.ticker;
          }
        }
        let financialsUrl =
          RenditionUrlGenerator.URL_GENERATOR.environments(environment) +
          `/directory/eppublic/company23/${ticker}/popup/financials`;

        const epfToken =  getStaticEPFAccessToken();
        if (!isEmpty(epfToken)) {
            financialsUrl = addParam(financialsUrl, '__epftoken', epfToken);
        }          

        if (window.HTML_RENDITION.isMCN) {
            companyCodeChangedFlag = this.currentSelectedCompanyCode == this.props.multiCompanyMetaData.companyCode;
        }
        if (!companyCodeChangedFlag) {
            this.currentSelectedCompanyCode = this.props.multiCompanyMetaData.companyCode;
        }

        // let title = this.props.finSumData && this.props.finSumData.FinancialSummary ? this.props.finSumData.FinancialSummary.FinancialSummaryTitle : '';
        // if (window.HTML_RENDITION.isMCN) {
        //     title = this.props.multiCompanyMetaData.companyNameAndTicker + title;
        // }
        // if (this.props.finSumData?.FinancialSummary?.FinancialSummaryTabs && companyCodeChangedFlag) 
        if (companyCodeChangedFlag) {
            HTML_RENDITION.hideLoadMask();
            window.HTML_RENDITION.openDetachURL = HTML_RENDITION.getDetachUrl('financialsContent', '', this.props.updateFinancialsContentTabTitle);
            commonStore.dispatch(commonStateAction.menuPaneStatus(''));
            if (deviceInfoService.isDeviceScreenType()) {
                $('.modal-financials .modal-body-height').css('overflow', 'auto');
            }
            $('#rightPartContain').removeAttr("style");
            return (this.state.modalStatus &&
                <ModalPopup classList={"modal-financials"}>
                    <NormalScreenPopup
                        bodySource={<TabsFinancialsContent showOldBranding={this.props.showOldBranding} selectComp={this.state.selectComp}/>}
                        modalBodyStyle={{ overflow: 'hidden' }}
                        titleSource={window.HTML_RENDITION.isMCN ? this.props.multiCompanyMetaData.companyNameAndTicker : this.props.docHeaderSectionJson.metadata.companyNameAndTicker}
                        openDetachURL={window.HTML_RENDITION.openDetachURL}
                        modalWindowStyle={{width: '100%', height: '95%'}}
                        iframeUrl={financialsUrl}
                    />
                </ModalPopup>);
        }
        if ((this.props.finSumData.isError || this.props.finSumData == '') && companyCodeChangedFlag) {
            HTML_RENDITION.hideLoadMask();
            const errorMsg = {
                message : '',
                type: 'showErrorPopup'
            };
            return (this.state.modalStatus &&
                <ShowErrorPopup msg={errorMsg} />
            );
        } else {
            HTML_RENDITION.showLoadMask();
            fetchFinSumData();
        }
    }

    public render() {
        const { docHeaderSectionJson, initialData, restrictionStatus } = this.props;
        const { publishingGroup, productFocus} = docHeaderSectionJson.metadata;
        const isEquitiesCompany = initialData.isFAVE && publishingGroup == 'CIR' && (productFocus == 'COMPANY' || productFocus == 'MULTICOMPANY');
        const isEquitiesIndustry = initialData.isFAVE && publishingGroup == 'CIR' && (productFocus == 'INDUSTRY' || productFocus == 'MULTICOMPANY');
        const rightPipe = {
            borderRight: '1px solid #DFD0BE',
            marginRight: docHeaderSectionJson.metadata.isJP ? '3px' : "8px",
            paddingRight: docHeaderSectionJson.metadata.isJP ? '0px' : "8px"
        };
        
        return (
            <React.Fragment>
                {/* {(this.showFinancials() || this.showIndustryComp()) && */}
                    <div id="requestFinancials">
                        <div className="financials" style={this.props.showAnalystModelComp ? rightPipe : {}} onClick={(e) => this.openModal(e)} onKeyPress={(e) => enterKeyPressed(e, this.openModal.bind(this, e))}>
                            {this.state.modalStatus && this.showModal()}
                            {/* <span className="icon-financials icon-sprite" role="img" aria-label={docHeaderSectionJson.i18n.financials} /> */}
                            <span className='icon-svg-parent'>
                                <span className="icon-svg icon-financials-svg" role="img" aria-label={docHeaderSectionJson.i18n.financials} />
                            </span>
                            {(!initialData.isFAVE || isEquitiesCompany) &&
                                <a style={{whiteSpace: "nowrap"}} tabIndex={0} role="link" aria-label={docHeaderSectionJson.i18n.financials}  id="requestFinancials-financials" className="x-rsch-hyperlink" data-entitlement="MULTI_TAB_STATAB_FINSUM" ref={this.MULTI_TAB_STATAB_FINSUM}>{docHeaderSectionJson.i18n.financials}</a>
                            }
                            {this.showIndustryComp() && (!initialData.isFAVE || isEquitiesCompany || isEquitiesIndustry ) && initialData.showSeparator('MULTI_TAB_STATAB_FINSUM', 'INDUSTRY_COMPARABLES') && !restrictionStatus &&
                                <span className="separator"> | </span>
                            }
                            {this.showIndustryComp() && (!initialData.isFAVE || isEquitiesCompany || isEquitiesIndustry ) && !restrictionStatus &&
                                <a tabIndex={0} role="link" aria-label={docHeaderSectionJson.i18n.industryComparables} id="requestFinancials-industryComp" className="x-rsch-hyperlink" data-entitlement="INDUSTRY_COMPARABLES" ref={this.INDUSTRY_COMPARABLES}>{docHeaderSectionJson.i18n.industryComparables}</a>
                            }
                        </div>
                    </div>
                 {/* } */}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        multiCompanyMetaData: state.commonStateReducer.multiCompanyMetaData,
        finSumData: state.asyncStateReducer.finSumData,
        updateFinancialsContentTabTitle: state.commonStateReducer.updateFinancialsContentTabTitle,
        menuPaneStatus: state.commonStateReducer.menuPaneStatus,
    };
};

export default connect(mapStateToProps)(FinancialsAndIndustry);
